import { apiFetch } from '../utils/apiFetch';

// LECTURE (admin et non-admin utilisent la même lecture)
export async function fetchTraumatoCatalog() {
  const r = await apiFetch('/traumato/catalog');
  if (!r.ok) throw new Error(`HTTP_${r.status}`);
  return r.json();
}

// ÉCRITURE ADMIN — attention au chemin: /api/traumato/admin/catalog
export async function saveTraumatoCatalog(catalog) {
  const r = await apiFetch('/traumato/admin/catalog', {
    method: 'PUT',
    body: JSON.stringify(catalog || { categories: [] }),
  });
  if (!r.ok) throw new Error(`HTTP_${r.status}`);
  return r.json();
}

// Commandes admin (add/move/delete)
export async function sendTraumatoCommands(ops = []) {
  const r = await apiFetch('/traumato/admin/commands', {
    method: 'POST',
    body: JSON.stringify({ ops }),
  });
  if (!r.ok) throw new Error(`HTTP_${r.status}`);
  return r.json();
}
